import { render, staticRenderFns } from "./closing-signed.vue?vue&type=template&id=671b489a"
import script from "./closing-signed.vue?vue&type=script&lang=js"
export * from "./closing-signed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports